import { ValidationErrors, ValidatorFn, AbstractControl } from "@angular/forms";
import { CURP } from "./curp";

export const curpValidator: ValidatorFn = (control: AbstractControl): ValidationErrors | null => {
  if (control.value == null || control.value == "") {
    return null;
  }
  const curp = control.value.toUpperCase();

  if (curp.length < 18) {
    return { invalidLength: true };
  } else {
    if (CURP.validate(curp)) {
      return CURP.validateLastDigit(curp) ? null : { invalidDigit: true };
    }
    return { invalidCurp: true };
  }
};
